/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { ApiQuery } from '@app/core/http/api-query';
import { AuthenticationService, Logger } from '@app/core';
import { Industry } from '@app/settings/industries/industries.model';
import { IndustriesService } from '@app/settings/industries/industries.service';
import { IndustriesFormService } from '@app/settings/industries/industries-form.service';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { IndustriesSeoFormService } from '@app/settings/industries/industries-seo-form.service';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('industriesListComponent');

@Component({
  selector: 'app-industries-list',
  templateUrl: './industries-list.component.html',
  styleUrls: ['./industries-list.component.scss'],
})
export class IndustriesListComponent extends KendoGridComponent implements OnInit {
  AuthenticationService = AuthenticationService;
  industriesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  UserRoleType = UserRoleType;

  constructor(
    private industryService: IndustriesService,
    private industriesSeoFormService: IndustriesSeoFormService,
    private industriesFormService: IndustriesFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('IndustriesListComponent');
    this.loadData(this.state);
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state);

    this.industryService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.industriesResponse = response;
      this.data = response.getGridData();
    });
    CustomKendoFilter.pushStateInStorage('IndustriesListComponent', this.state);
  }

  add() {
    this.industriesFormService.open().then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param industry Industry object
   */
  edit(industry: Industry) {
    this.industriesFormService.open(industry);
  }

  /**
   *
   * @param industry Industry object
   */
  delete(industry: Industry) {
    this.industryService.destroy(industry.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  editSeo(industry: Industry): void {
    this.industriesSeoFormService.open(industry);
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
